var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rsl-loader",style:(_vm.loader)},[_c('div',{class:[_vm.iconClass, ("rsl-loader__" + _vm.viewType)],style:(_vm.loaderStyles)})])}
var staticRenderFns = []

export { render, staticRenderFns }